export default "__VITE_ASSET__qvbRGPIi__";